import { IsUUID, IsOptional } from 'class-validator';

export class ManagerSubstitutesDto {
  @IsUUID()
  @IsOptional()
  companyId?: string;

  @IsUUID()
  @IsOptional()
  employeeId?: string;
}
